import Vue from 'vue'
import Vuex from 'vuex'

// XXX backward compat
import _locator from '@/service-locator'

import getters from './getters'
import modules from './modules'

const buildRootStore = (locator) => {
  Vue.use(Vuex)

  const store = new Vuex.Store({
    modules,
    getters,
  })

  locator.store = store
  return store
}

export { buildRootStore }

// XXX backward compat, remove later on
export default _locator.store
